import { render, staticRenderFns } from "./BFileInput.vue?vue&type=template&id=61ebfc48"
import script from "./BFileInput.vue?vue&type=script&lang=js"
export * from "./BFileInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports